/** String coercion shared by the export mapper — mirrors the adapter's `str`. */
export const str = (v: unknown): string =>
  typeof v === 'string' ? v : typeof v === 'number' || typeof v === 'bigint' ? String(v) : '';

/** ClickUp-style field unwrapping: raw n8n values arrive as plain strings OR
 *  {value}/{status}/{label}/{name} objects, OR single-element arrays. The
 *  transformers unwrap via extractFieldValue; the export mapper needs the same
 *  rule or every object-wrapped field reads as empty. */
export const fieldValue = (v: unknown): string => {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) return v.length ? fieldValue(v[0]) : '';
  if (typeof v === 'object') {
    const o = v as Record<string, unknown>;
    return fieldValue(o.value ?? o.status ?? o.label ?? o.name);
  }
  return typeof v === 'string' ? v : typeof v === 'number' || typeof v === 'bigint' ? String(v) : '';
};
